import React, {FC, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {fetchData, getEncryptedRoute, handleTimeChange, toasterrormsg, toastsuccessmsg, useMenuIdPermissions} from '../../../reusable'
import {ToastContainer} from 'react-toastify'
import Select, { CSSObjectWithLabel } from 'react-select'
import moment from 'moment'
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import Swal from 'sweetalert2'
import { Tr } from '../../../_metronic/i18n/Tr'

interface BookingDetailsHeaderProps {
  bookingId: string // Assuming bookingId is of type string, adjust as needed
  bookingdetailId: string // Assuming bookingId is of type string, adjust as needed
}

const BookingDetail: React.FC<BookingDetailsHeaderProps> = ({bookingId, bookingdetailId}) => {
  let t = Tr()
      const {  menuId} = useMenuIdPermissions()


  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [selectedStatus, setSelectedStatus] = useState<any>([])
  const [originalStatus, setOriginalStatus] = useState<string>('')
  const [selectedRoom, setSelectedRoom] = useState<any>([])

  const [roomList, setRoomList] = useState([])
  const [hotelId, setHotelId] = useState('')
  const [roomId, setRoomId] = useState('')
  const [statusList] = useState([
    {value: '0', label: 'pending'},
    {value: '1', label: 'Approved'},
    {value: '2', label: 'Rejected'},
    {value: '3', label: 'Cancelled'},
    // {value: '4', label: 'Completed'},
  ]) as any

  const [fromTime, setFromTime] = useState('')
  const [toTime, setToTime] = useState('')
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [adult, setAdult] = useState('')
  const [infant, setInfant] = useState('')
  const [child, setChild] = useState('')
  const [quantity, setQuanity] = useState('')
  const [bookingType, setBookingType] = useState('')
  const [detailBookingId, setDetailBookingId] = useState('')

  const [error, setError] = useState([
    {
      roomType: '',
      bedType: '',
      room: '',
      fromDate: '',
      toDate: '',
      quantity: '',
      fromTime: '',
      toTime: '',
    },
  ])

  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  const validate = () => {
    var isValid = true
    const regex = /^[0-9]*$/
    var errorTmp = [...error]
    if (bookingType == 'byTime') {
      if (fromTime == '') {
        errorTmp[0].fromTime = t('From Time Is Required')
        isValid = false
      } else if (toTime == '') {
        errorTmp[0].toTime = t('To Time Is Required')
        isValid = false
      } else if (fromTime > toTime) {
        errorTmp[0].fromTime = t("From Time Can't be Greater than to time")
        isValid = false
      } else if (fromTime == toTime) {
        errorTmp[0].fromTime = t("From Time Can't be Equal to To time")
        isValid = false
      }
    } else {
      if (fromDate == '') {
        errorTmp[0].fromDate = t('From Date Is Required')
        isValid = false
      } else if (toDate == '') {
        errorTmp[0].toDate = t('To Date is Required')
        isValid = false
      } else if (fromDate > toDate) {
        errorTmp[0].fromDate = t("From Date Can't be Greater than to Date")
        isValid = false
      } else if (fromDate == toDate) {
        errorTmp[0].fromDate = t("From Date Can't be Equal to To Date")
        isValid = false
      }
    }

    if (!regex.test(quantity)) {
      errorTmp[0].quantity = t('Characters are not allowed')
      isValid = false
    }
    setError(errorTmp)
    return isValid
  }

  const editBookingDetails = async () => {
    if (validate()) {
      let swalOptions: any = null // Initialize as null

      if ((selectedStatus.value == 2 || selectedStatus.value == 3) && String(selectedStatus.value) !== originalStatus) {
        if (selectedStatus.value == '2') {
          swalOptions = {
            title: t('Are You Sure? You Want to Reject This Booking.'),
            icon: 'warning',
            showCancelButton: true,
            input: 'text',
            inputLabel: 'Reason',
            inputPlaceholder: t('Enter Reject Reason'),
            inputValidator: (value: any) => {
              if (!value) {
                return t('Reject Reason Required!')
              }
            },
          }
        } else if (selectedStatus.value == '3') {
          swalOptions = {
            title: t('Are You Sure? You Want to Cancel This Booking.'),
            icon: 'warning',
            showCancelButton: true,
            input: 'text',
            inputLabel: 'Reason',
            inputPlaceholder: t('Enter Cancel Reason'),
            inputValidator: (value: any) => {
              if (!value) {
                return t('Cancel Reason Required!')
              }
            },
          }
        }
      }

      const updateBooking = async (inputValue = null) => {
        var tmp2 = sessionStorage.getItem('admin')
        // Step 2: Check if the item is not null
        if (tmp2) {
          // Step 3: Parse the JSON string
          var adminData = JSON.parse(tmp2)
          // Step 4: Access the adminId
          var adminId = adminData.adminId
        }

        setDisable(true)
        setLoading(true)
        var tmp2 = sessionStorage.getItem('admin')
        // Step 2: Check if the item is not null
        if (tmp2) {
          // Step 3: Parse the JSON string
          var adminData = JSON.parse(tmp2)
          // Step 4: Access the adminId
          var adminId = adminData.adminId
        }
        var param: any = {
          updateStatus: '1',
          bookingId: String(bookingId),
          bookingdetailId: bookingdetailId,
          bookingDetailStatus: selectedStatus ? selectedStatus.value : '',
          adminId: adminId,
          actionTypeId: selectedRoom ? String(selectedRoom.value) : '',
          fromDate: fromDate,
          toDate: toDate,
          fromTime: fromTime == '' ? '00:00' : String(fromTime),
          toTime: toTime == '' ? '00:00' : String(toTime),
          quantity: String(quantity),
          bookByDay: bookingType == 'byTime' ? '1' : '0',
          adult: adult == '' ? '0' : String(adult),
          child: child == '' ? '0' : String(child),
          infant: infant == '' ? '0' : String(infant),
        }

        let param2: {[key: string]: any} = {
          bookingId: bookingId,
          adminId: adminId,
          reason: inputValue,
          status: selectedStatus.value,
        }

        if (selectedStatus.value == 3) {
          param2.bookingdetailId = bookingdetailId
          param2.cancellationDate = moment().format('YYYY-MM-DD HH:mm:ss.SSZZ')
          var res2 = await fetchData('admin/cancelbooking', param2)
        } else if (selectedStatus.value == 2) {
          param2.categoryId = 1
          // var res3 = await fetchData('admin/rejectbooking', param2)
          var res4 = await fetchData('admin/approverejectbooking', param2)
        }

        if (selectedStatus.value == 2) {
          // if (res3.status == '200') {
          //   toastsuccessmsg(res3.message)
          // } else {
          //   toasterrormsg(res3.message)
          // }

          if (res4.status == '200') {
            toastsuccessmsg(res4.message)
          } else {
            toasterrormsg(res4.message)
          }
          setDisable(false)
          setLoading(false)
          BookingListApiCall()
        }

        if (selectedStatus.value == 3) {
          if (res2.status == '200') {
            toastsuccessmsg(res2.message)
          } else {
            toasterrormsg(res2.message)
          }
          setDisable(false)
          setLoading(false)
          BookingListApiCall()
        }

        if (selectedStatus.value != 2 && selectedStatus.value != 3) {
          var res = await fetchData('admin/editbooking', param)
        }

        if (selectedStatus.value != 2 && selectedStatus.value != 3) {
          if (res.status == '200') {
            setDisable(false)
            setLoading(false)
            BookingListApiCall()
            toastsuccessmsg('Updated Successfully')
          } else {
            setDisable(false)
            setLoading(false)
            toasterrormsg(res.message)
          }
        }
      }
      if (swalOptions) {
        Swal.fire(swalOptions).then(async (result) => {
          if (result.isConfirmed) {
            await updateBooking(result.value)
          } else {
            setDisable(false)
            setLoading(false)
          }
        })
      } else {
        // For other statuses (like approval), update directly without Swal
        await updateBooking()
      }
    }
  }

  const formatDate = (date: any) => {
    if (date == null || date == '') {
      var today: any = new Date()
      var date: any = moment(today).format('yyyy-MM-DD')
      return date
    }

    return moment(date).format('yyyy-MM-DD')
  }

  const BookingListApiCall = async () => {
    var param: any = {
      bookingId: bookingId,
      categoryId: '1',
    }

    var res = await fetchData('admin/bookingdetail', param)

    if (res.status == '200') {
      var data = res.data
    
      setDetailBookingId(data[0].bookingId)
      data.map((items: any) => {
        var bookingDetail = items.bookingDetail.filter(
          (item: any) => item.bookingdetailId == bookingdetailId
        )

        setHotelId(bookingDetail[0].actionDetail[0].hotelId)
        setRoomId(bookingDetail[0].actionTypeDetail[0].roomId)
        setBookingType(bookingDetail[0].bookingType)

        if (bookingDetail[0].status == '') {
          setSelectedStatus({value: '0', label: 'Pending'})
          setOriginalStatus('0')
        } else {
          var selectedStatus = statusList.filter(
            (item: any) => item.value == bookingDetail[0].status
          )
          setSelectedStatus(selectedStatus[0])
          setOriginalStatus(String(bookingDetail[0].status))
        }

        setFromDate(formatDate(bookingDetail[0].fromDate))
        setToDate(formatDate(bookingDetail[0].toDate))
        setFromTime(bookingDetail[0].fromTime)
        setToTime(bookingDetail[0].toTime)

        setAdult(bookingDetail[0].adult)
        setChild(bookingDetail[0].child)
        setInfant(bookingDetail[0].infant)
        setQuanity(bookingDetail[0].quantity)
      })
    } else {
    }
  }

  const hotelDetailsApiCall = async () => {
    var param: any = {
      hotelId: hotelId,
    }
    var response: any = await fetchData('vendor/public/hotelDetailsV2', param)

    if (response.status == '200') {
      var roomList = response.data[0]['roomList']
      var opt: any = []
      roomList.map((val: any) => {
        opt.push({value: val.roomId, label: val.en_roomName})
      })

      setRoomList(opt)
      var selectedRoom = opt.filter((item: any) => item.value == roomId)
      setSelectedRoom(selectedRoom[0])
    } else {
    }
  }

  useEffect(() => {
    BookingListApiCall()
  }, [])
  useEffect(() => {
    hotelDetailsApiCall()
  }, [hotelId])

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
        { t('Edit Booking Details') }
      </PageTitle>
      <div className='d-flex flex-column flex-column-fluid'>
        {/* <!--begin::Content--> */}
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/* <!--begin::Form--> */}
          <div className='form d-flex flex-column flex-lg-row'>
            {/* <!--begin::Main column--> */}
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              {/* <!--begin::Tab content--> */}
              <div className='tab-content'>
                {/* <!--begin::Tab pane--> */}
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    {/* <!--begin::General options--> */}
                    <div className='card card-flush py-4'>
                      {/* <!--begin::Card header--> */}
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>{t("Booking Details")}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                      </div>

                      <div className='card-body pt-0'>
                        <div className='row'>
                          {/* <div className='col-lg-4 my-3'>
                            <label className='required fs-4 form-label'>Room Type List</label>

                            <Select
                              name='roomTypeList[]'
                              id='roomTypeList'
                              placeholder='Select Room Type'
                              isSearchable={true}
                              isMulti
                              options={roomTypeList}
                              value={roomTypeSelectedOptions}
                              onChange={(e: any) => {
                                setRoomTypeSelectedOption(e)
                                removeError('roomType')
                              }}
                            />
                            <div className='text-danger fw-bold'>{error[0].roomType}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            <label className='required fs-4 form-label'>Bed Type List</label>

                            <Select
                              name='bedTypeList[]'
                              id='tourTypeList'
                              placeholder='Select Bed Type'
                              isSearchable={true}
                              isMulti
                              options={bedTypeList}
                              value={bedTypeSelectedOptions}
                              onChange={(e: any) => {
                                setBedTypeSelectedOption(e)
                                removeError('bedType')
                              }}
                            />
                            <div className='text-danger fw-bold'>{error[0].bedType}</div>
                          </div> */}

                          <div className='col-lg-4 my-3'>
                            <label className='required fs-4 form-label'>{t("Selected Room")}</label>

                            <Select
                              name='selectedRoom'
                              id='selectedRoom'
                              placeholder={t('Select Room')}
                              isSearchable={true}
                              options={roomList}
                              value={selectedRoom}
                              onChange={(e: any) => setSelectedRoom(e)}
                              styles={{
                                container: (provided : CSSObjectWithLabel) => ({...provided, width: '100%'}),
                                control: (provided : CSSObjectWithLabel) => ({...provided, minHeight: 43}),
                              }}
                            />
                            <div className='text-danger fw-bold'>{error[0].room}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>{t("Select Status")}</label>

                            <Select
                              name='SelectStatus'
                              id='SelectStatus'
                              placeholder={t('Select Status')}
                              isSearchable={true}
                              options={statusList}
                              value={selectedStatus}
                              onChange={(e: any) => {
                                setSelectedStatus(e)
                              }}
                              styles={{
                                container: (provided : CSSObjectWithLabel) => ({...provided, width: '100%'}),
                                control: (provided : CSSObjectWithLabel) => ({...provided, minHeight: 43}),
                              }}
                            />
                          </div>

                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>{t("Number of Rooms")}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='quantity'
                              placeholder={t('Quantity')}
                              className='form-control mb-2'
                              value={quantity}
                              disabled={true}
                              onChange={(e) => {
                                removeError('quantity')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].quantity}</div>
                          </div>

                          {bookingType == 'byTime' ? (
                            <>
                              <div className='col-lg-4 my-3'>
                                <label className='fs-4 form-label required'>{t("From Time")}</label>
                                <Flatpickr
                                  data-enable-time
                                  name='startTime'
                                  className='form-control mb-2'
                                  value={fromTime}
                                  options={{
                                    enableTime: true, // Enable time selection
                                    noCalendar: true, // Hide the date picker, only show time
                                    dateFormat: 'H:i', // 24-hour format (H:i)
                                    time_24hr: true, // Enforces 24-hour format
                                    minuteIncrement: 15, // 15-minute increments in dropdown
                                    allowInput: false, // Allow typing custom times
                                  }}
                                  defaultValue={'00:00'}
                                  onChange={(date: any) => {
                                    setFromTime(handleTimeChange(date))
                                    removeError('fromTime')
                                    removeError('toTime')
                                  }}
                                />
                                {/* <Flatpickr
                                              data-enable-time
                                              value={fromAvailableHours}
                                              onChange={(date) => {setFromAvailableHours(handleTimeChange(date));removeError('fromAvailableHours');}}
                                              options={{
                                                  enableTime: true,        // Enable time selection
                                                  noCalendar: true,        // Hide the date picker, only show time
                                                  dateFormat: 'H:i',       // 24-hour format (H:i)
                                                  time_24hr: true,         // Enforces 24-hour format
                                                  minuteIncrement: 15,     // 15-minute increments in dropdown
                                                  allowInput: false,        // Allow typing custom times
                                              }}
                                              defaultValue={'00:00'}
                                              className="form-control mb-2"
                                          /> */}
                                <div className='text-danger fw-bold'>{error[0].fromTime}</div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                <label className='fs-4 form-label required'>{t("To Time")}</label>
                                <Flatpickr
                                  data-enable-time
                                  name='toTIme'
                                  className='form-control mb-2'
                                  value={toTime}
                                  options={{
                                    enableTime: true, // Enable time selection
                                    noCalendar: true, // Hide the date picker, only show time
                                    dateFormat: 'H:i', // 24-hour format (H:i)
                                    time_24hr: true, // Enforces 24-hour format
                                    minuteIncrement: 15, // 15-minute increments in dropdown
                                    allowInput: false, // Allow typing custom times
                                  }}
                                  defaultValue={'00:00'}
                                  onChange={(date: any) => {
                                    if (handleTimeChange(date) == '00:00') {
                                      setToTime('23:45')
                                    } else {
                                      setToTime(handleTimeChange(date))
                                    }
                                    removeError('fromTime')
                                    removeError('toTime')
                                  }}
                                />
                                <div className='text-danger fw-bold'>{error[0].toTime}</div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>{t("Check In")}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='date'
                                  name='fromDate'
                                  className='form-control mb-2'
                                  value={fromDate}
                                  min={new Date().toISOString().split('T')[0]} // Set the min attribute to today's date
                                  onKeyDown={(e) => e.preventDefault()}
                                  onChange={(e) => {
                                    setFromDate(e.target.value)
                                    removeError('fromDate')
                                    removeError('toDate')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].fromDate}</div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>{t("Check Out")}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='date'
                                  name='toDate'
                                  className='form-control mb-2'
                                  value={toDate}
                                  min={new Date().toISOString().split('T')[0]} // Set the min attribute to today's date
                                  onKeyDown={(e) => e.preventDefault()}
                                  onChange={(e) => {
                                    setToDate(e.target.value)
                                    removeError('toDate')
                                    removeError('fromDate')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].toDate}</div>
                              </div>
                            </>
                          )}

                          <div className='col-lg-4 my-3'>
                            <div className='row'>
                              {/* <!--begin::Label--> */}
                              <label className='fs-4 form-label'>{t("Booking Type")}</label>
                              {/* <!--end::Label--> */}
                              <div className='col-4 my-2'>
                                <label className='d-flex text-start' data-kt-button='true'>
                                  {/* <!--begin::Radio--> */}
                                  <span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                                    <input
                                      className='form-check-input'
                                      type='radio'
                                      disabled={true}
                                      name='bookingType'
                                      value='byTime'
                                      checked={bookingType == 'byTime'}
                                      onChange={(e: any) => {}}
                                    />
                                  </span>
                                  {/* <!--end::Radio--> */}
                                  {/* <!--begin::Info--> */}
                                  <span className='ms-5'>
                                    <span className='fs-4 fw-bold text-gray-800 d-block'>
                                      {t("By Time")}
                                    </span>
                                  </span>
                                  {/* <!--end::Info--> */}
                                </label>
                              </div>
                              <div className='col-4 my-2'>
                                <label className='d-flex text-start' data-kt-button='true'>
                                  {/* <!--begin::Radio--> */}
                                  <span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                                    <input
                                      className='form-check-input'
                                      type='radio'
                                      name='bookingType'
                                      disabled={true}
                                      value='byDay'
                                      checked={bookingType == 'byDay'}
                                      onChange={(e: any) => {}}
                                    />
                                  </span>
                                  {/* <!--end::Radio--> */}
                                  {/* <!--begin::Info--> */}
                                  <span className='ms-5'>
                                    <span className='fs-4 fw-bold text-gray-800 d-block'>
                                      {t("By Day")}
                                    </span>
                                  </span>
                                  {/* <!--end::Info--> */}
                                </label>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div className='d-flex justify-content-end'>
                <Link
                  to={getEncryptedRoute('../viewhotelbookingdetails/', {menuId:menuId})}
                  id='kt_ecommerce_add_product_cancel'
                  className='btn btn-light me-5'
                  state={{bookingId: detailBookingId}}
                >
                  {t("Cancel")}
                </Link>

                <button
                  onClick={() => {
                    editBookingDetails()
                  }}
                  type='button'
                  disabled={disable}
                  className='btn btn-primary'
                >
                  <span className='indicator-label'>{t("Save")}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>
                {/* <!--end::Button--> */}
              </div>
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export {BookingDetail}
